import { PARTNERS } from "@/config/site";
import styles from "./ReservationCard.module.css";

export function ReservationCard() {
  return (
    <div className={styles.card}>
      <div className={styles.priceRow}>
        <span className={styles.price}>Book your stay</span>
        <span className={styles.priceNote}>
          Reserve instantly through our trusted partners
        </span>
      </div>

      <div className={styles.bookBtns}>
        <a
          className={`${styles.bookBtn} ${styles.airbnb}`}
          href={PARTNERS.airbnb}
          target="_blank"
          rel="noopener noreferrer"
        >
          Book on Airbnb
        </a>
        <a
          className={`${styles.bookBtn} ${styles.vrbo}`}
          href={PARTNERS.vrbo}
          target="_blank"
          rel="noopener noreferrer"
        >
          Book on Vrbo
        </a>
      </div>

      <p className={styles.note}>
        See live availability, rates, and reviews on Airbnb or Vrbo.
      </p>
    </div>
  );
}
